import { render, staticRenderFns } from "./StepsComponent.vue?vue&type=template&id=4e24d130&scoped=true&"
import script from "./StepsComponent.vue?vue&type=script&lang=js&"
export * from "./StepsComponent.vue?vue&type=script&lang=js&"
import style0 from "./StepsComponent.vue?vue&type=style&index=0&id=4e24d130&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e24d130",
  null
  
)

export default component.exports